import React, { useState, useEffect } from 'react';
import { StyledStatesFilterDiv } from './index.styles';
import { StyledCheckboxItemDiv, StyledCheckboxItemsContainer } from '../../organisms/SearchResults/index.styles';

import { SearchFacetsList, SearchFacetsListCodes } from '../../organisms/SearchResults/index.constant';
import {
  SearchFacetsResponse,
  SearchFacetsResponseBuckets,
  SearchStateExtendsType,
  SearchStateFilterObj,
} from '../../organisms/SearchResults/store/store.type';
import { useWindowSize } from '../../hooks';
import { BREAKPOINT_DESKTOP_1023, BREAKPOINT_TABLET } from '../../organisms/SearchResults/lib/application.constants';
import { formatNumberByLocale } from '../../utils';
import { useConditionalSessionUpdateContext } from '../../hooks';
import { useConditionalPageContextSERP } from '../../hooks';
import { CheckBox, checkboxVariation } from '@marriott/mi-ui-library';
import { useConditionalSearchFilterContextWithSerpFlag } from '../../hooks/lib/useConditionalSearchFilterContext';
declare module 'react' {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface HTMLAttributes<T> {
    custom_click_track_value?: string;
  }
}

export const StateFilterComponent: React.FC<{
  onItemSelect: (arg: SearchFacetsList, arg2: SearchStateFilterObj) => void;
  clearFilterState: SearchStateExtendsType | undefined | null;
  statesList?: SearchFacetsResponse;
}> = ({ onItemSelect, clearFilterState, statesList }) => {
  const { searchQueryState } = useConditionalSearchFilterContextWithSerpFlag();
  const { currentLocale } = useConditionalPageContextSERP();
  const { interactionsSelected, setInteractionsSelected } = useConditionalSessionUpdateContext();
  const clickTrackingLoc = 'Phoenix Search Results';

  const [currSelectedItem, setCurrSelectedItem] = useState<SearchStateFilterObj | undefined>(
    searchQueryState[SearchFacetsList.states]
  );
  const { width } = useWindowSize();

  const getCurrStateList = (): SearchFacetsResponse =>
    statesList
      ? statesList
      : // eslint-disable-next-line @typescript-eslint/no-explicit-any
        searchQueryState?.filter?.filter((key: any) => key.type.code === SearchFacetsListCodes.states)[0];

  const [stateList, setStateList] = useState<SearchFacetsResponse>(getCurrStateList());

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const onSelectionChange = (event: any, data: SearchFacetsResponseBuckets): void => {
    if (event.key === 'Enter' || event.type === 'click' || event.type === 'change' || event.keyCode === 13) {
      let obj: SearchStateFilterObj | undefined = { ...currSelectedItem };
      if (obj !== undefined) {
        if (data.code in obj) {
          delete obj[data.code];
        } else {
          obj[data.code] = data.code;
        }
      } else {
        obj = {};
        obj[data.code] = data.code;
      }
      setCurrSelectedItem(obj);
      if (onItemSelect) {
        onItemSelect(SearchFacetsList.states, obj);
      }
    }
    setInteractionsSelected({ ...interactionsSelected, states: true });
  };

  useEffect(() => {
    if (clearFilterState === undefined || clearFilterState === null) {
      setCurrSelectedItem(undefined);
    }
  }, [clearFilterState]);
  useEffect(() => {
    setStateList(getCurrStateList());
  }, [statesList]);
  return stateList?.type?.count ? (
    <StyledStatesFilterDiv className="t-font-alt-m hotel-types-filters-container">
      <fieldset>
        <div className="t-font-alt-m filter-heading-container">
          <legend>
            <h4
              className={
                (width && width > BREAKPOINT_DESKTOP_1023
                  ? `t-subtitle-l`
                  : width && width > BREAKPOINT_TABLET
                  ? `t-subtitle-l`
                  : `t-subtitle-m`) + ' filter-heading'
              }
            >
              {stateList?.type?.label}
            </h4>
          </legend>
        </div>
        <StyledCheckboxItemsContainer>
          {stateList?.buckets?.map((state: SearchFacetsResponseBuckets, idx: number) => (
            <StyledCheckboxItemDiv className="m-checkbox-selection-item hotel-type-description" key={idx}>
              <CheckBox
                variation={checkboxVariation.SIMPLE}
                className=""
                checkboxId={`states-${state?.code}-checkbox`}
                checkboxName="state_filter_checkbox"
                onChange={(e): void => onSelectionChange(e, state)}
                onKeyDown={(e): void => onSelectionChange(e, state)}
                checked={currSelectedItem ? state.code in currSelectedItem === true : false}
                inputClassName="checkbox-input custom_click_track"
                setTabIndex={-1}
                children={
                  <>
                    <span className="t-font-s">{state?.label}</span>
                    {state?.count && (
                      <span className="t-font-s pl-1">({formatNumberByLocale(state?.count, currentLocale)})</span>
                    )}
                  </>
                }
                {...{ custom_click_track_value: `${clickTrackingLoc}| State options: ${state?.label} |internal` }}
              />
            </StyledCheckboxItemDiv>
          ))}
        </StyledCheckboxItemsContainer>
      </fieldset>
      <hr aria-hidden className="filter-separator" />
    </StyledStatesFilterDiv>
  ) : (
    <span></span>
  );
};
